/**
 * @param {string} text
 * @returns {number}
 */
export function countWords (text) {
  if (!text || typeof text !== 'string') return 0
  const normalized = text.replace(/\s+/g, ' ').trim()
  if (!normalized) return 0
  return normalized.split(' ').filter((w) => w.length > 0).length
}

/**
 * Strip tags from HTML fragments (UDF paragraph / quote fields).
 * @param {string} html
 * @returns {string}
 */
export function plainTextFromHtml (html) {
  if (!html || typeof html !== 'string') return ''
  if (typeof document === 'undefined') {
    return html.replace(/<[^>]+>/g, ' ')
  }
  const doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html')
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim()
}

/**
 * Body-only UDF count: paragraphs and blockquotes; no image captions or other blocks.
 * @param {unknown[]} body
 * @returns {number}
 */
export function countWordsFromUdfBody (body) {
  if (!Array.isArray(body)) return 0
  const parts = []
  for (const block of body) {
    if (!block || typeof block !== 'object') continue
    if (block._type === 'paragraph' && block.content) {
      parts.push(plainTextFromHtml(String(block.content)))
    }
    if (block._type === 'blockquote' && block.quote) {
      parts.push(plainTextFromHtml(String(block.quote)))
    }
  }
  return countWords(parts.join(' '))
}
